import { Component } from '@angular/core';

@Component({
    selector: 'atx-chat-list',
    template: `<div class="chat-list">
    <div class="chat-box">
            <span class="img-hold">
                <img src="../img/leroy.png" alt="logo business">
            </span>
        <div>
            <p class="title">Leroy Merlín S.A.</p>
            <a href="#" class="job">Asesor/a especialista en Decoración de interiores</a>
            <p class="reference">
                Ref. 2645677
                <a href="#" class="mute">Silenciar</a>
            </p>
        </div>
    </div>
    <div class="chat-box">
            <span class="img-hold">
                <img src="../img/leroy.png" alt="logo business">
            </span>
        <div>
            <p class="title">Leroy Merlín S.A.</p>
            <a href="#" class="job">Asesor/a especialista en Decoración de interiores</a>
            <p class="reference">
                Ref. 2645677
                <a href="#" class="mute">Silenciar</a>
            </p>
        </div>
    </div>
</div>
`,
    styles: [``],
})

export class AtxChatListComponent {}
